import { app } from "@microsoft/teams-js";
import { markTeamsInitialized, markTeamsInitFailed } from "./helpers/teamsApp";

app.initialize()
    .then(() => {
        app.notifyAppLoaded();
        app.notifySuccess();
        markTeamsInitialized();
    })
    .catch((e) => {
        console.error("Teams SDK failed:", e);
        markTeamsInitFailed(e);
    });

import "./helpers/teamsApp";
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import reducers from './reducers';
import thunk from 'redux-thunk';

const store = createStore(reducers, applyMiddleware(thunk));

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <App />
    </Provider>
);

serviceWorker.unregister();